import React, { useEffect, useState } from "react";
import { backend, GroupData, Role } from "../../services";
import MultiCheckbox from "../../components/ui/multiCheckbox";
import DateInput from "../../components/ui/dateInput";
import { SearchIcon } from "../../icons";
import {
  UserFilters,
  defaultUserListFilters,
  userFiltersCacheKey,
} from "../../forms/filters/user";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { UserShortInfo } from "types";
import { currentUserGroupFilter } from "../../state/functions";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducer";
import { CheckboxInput, FormRow, TextInput } from "../../modals/components";

interface UserFilterModalProps {
  onApplyFilters: (filters: UserFilters) => void;
  closeModal: () => void;
}

const UserFilterModal: React.FC<UserFilterModalProps> = ({
  onApplyFilters,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const [filters, setFilters] = useState<UserFilters>(defaultUserListFilters);
  const groupList = State.groupsToSelect;
  const [roleList, setRoleList] = useState<Role[]>([]);
  // const [usersToSelect, setUsersToSelect] = useState<UserShortInfo[]>([]);
  const rights = State.rights;

  useEffect(() => {
    const cachedFilters = localStorage.getItem(userFiltersCacheKey);
    if (cachedFilters) {
      const lastFilters: UserFilters = JSON.parse(cachedFilters);
      setFilters(lastFilters);
    }
  }, []);

  useEffect(() => {
    backend.getRoleList().then((res) => setRoleList(res.roles));
    // backend.getAllUsersShorts(currentUserGroupFilter()).then((res) => setUsersToSelect(res.users));
  }, [groupList]);

  const handleParamChange = (name: keyof UserFilters, value: any) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiCheckboxChange = (
    name: keyof UserFilters,
    selectedIds: number[]
  ) => {
    setFilters((prev) => ({ ...prev, [name]: selectedIds }));
  };

  const applyFilters = () => {
    const dataToCache = JSON.stringify(filters);
    localStorage.setItem(userFiltersCacheKey, dataToCache);
    onApplyFilters(filters);
    closeModal();
  };

  return (
    <div className="creationForm filterForm">
      <div className="modalHeading">
        <h3>Фильтры пользователей</h3>
      </div>
      <form className="columnCenter">
        <FormRow label="Группы">
          <div className="fieldInput flex">
            <MultiCheckbox
              items={groupList}
              selectedIds={filters.group_ids || []}
              onChange={(ids) => handleMultiCheckboxChange("group_ids", ids)}
            />
          </div>
        </FormRow>
        <CheckboxInput
          label="Искать в подгруппах"
          checked={filters.search_in_subgroup || false}
          onChange={(e) =>
            handleParamChange("search_in_subgroup", e.target.checked)
          }
        />
        <div className="flex formRow">
          <div className="fieldName">Роли</div>
          <div className="fieldInput flex">
            <MultiCheckbox
              items={roleList}
              selectedIds={filters.role_ids || []}
              onChange={(ids) => handleMultiCheckboxChange("role_ids", ids)}
            />
          </div>
        </div>
        <CheckboxInput
          label="Активен"
          checked={filters.active || false}
          onChange={(e) => handleParamChange("active", e.target.checked)}
        />
        <div className="flex formRow">
          <div className="fieldName">Дата приёма</div>
          <div className="fieldInput flex between gap24 dateFromTo">
            <DateInput
              value={filters.date_employed_min || ""}
              onSelect={(date) => handleParamChange("date_employed_min", date)}
            />
            <DateInput
              value={filters.date_employed_max || ""}
              onSelect={(date) => handleParamChange("date_employed_max", date)}
            />
          </div>
        </div>
        <div className="flex formRow">
          <div className="fieldName">Дата увольнения</div>
          <div className="fieldInput flex between gap24 dateFromTo">
            <DateInput
              value={filters.date_unemployed_min || ""}
              onSelect={(date) =>
                handleParamChange("date_unemployed_min", date)
              }
            />
            <DateInput
              value={filters.date_unemployed_max || ""}
              onSelect={(date) =>
                handleParamChange("date_unemployed_max", date)
              }
            />
          </div>
        </div>
        <div className="flex formRow">
          <div className="fieldName">Направление сортировки</div>
          <div className="fieldInput flex">
            <select
              value={filters.sortDirection}
              onChange={(e) =>
                handleParamChange(
                  "sortDirection",
                  e.target.value as "ASC" | "DESC"
                )
              }
            >
              <option value="ASC">По возрастанию</option>
              <option value="DESC">По убыванию</option>
            </select>
          </div>
        </div>
        <div className="flex btnRow">
          <button className="filterButton" type="button" onClick={applyFilters}>
            <SearchIcon width={32} height={32} />
            <span>Искать</span>
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserFilterModal;
